import DialogContent from '@mui/material/DialogContent'
import { DataEditContextTextField } from 'Components/reusable/DataContext/fields/DataEditContextTextField'
import { DataEditContextDateField } from 'Components/reusable/DataContext/fields/DataEditContextDateField'
import { DataEditContextDateResolutionField } from 'Components/reusable/DataContext/fields/DataEditContextDateResolutionField'
import { DataEditContextTranslationImport } from 'Components/reusable/DataContext/TranslationImport'
import React from 'react'
import Grid from '@mui/material/Grid2'
import CardContentText from 'Components/reusable/CaleoCustomComponents/CardContentText'
import newWithEditModal from 'Components/reusable/HOC/newWithEditModal'
import { ILeisureActivity } from 'types/cvsInterfaces'
import { useTranslation } from 'react-i18next'

const LeisureActivityModal: React.FC<Record<string, unknown>> = () => {
  const { t } = useTranslation()

  return (
    <DialogContent>
      <Grid container spacing={2}>
        <Grid>
          <DataEditContextTranslationImport<ILeisureActivity> />
          <DataEditContextTextField<ILeisureActivity> field="name" required fullWidth insetLabel />
          <DataEditContextTextField<ILeisureActivity>
            field="activityType"
            fullWidth
            insetLabel
            placeholder={t('profile.leisureActivity.modal.activityTypePlaceholder')}
            helperText={t('profile.leisureActivity.modal.activityTypeHelp')}
          />
          <DataEditContextTextField<ILeisureActivity>
            field="description"
            maxHintLength={1500}
            multiline
            grow
            rows={10}
            fullWidth
            insetLabel
          />
          <Grid container spacing={2}>
            <Grid size={6}>
              <DataEditContextDateResolutionField<ILeisureActivity> field="dateResolution" required />
            </Grid>
            <Grid size={6}>
              <DataEditContextDateField<ILeisureActivity> field="startDate" isClearable start={true} insetLabel />
              <DataEditContextDateField<ILeisureActivity> field="endDate" isClearable end={true} insetLabel />
            </Grid>
          </Grid>
          <CardContentText type="description">{t('profile.leisureActivity.modal.dateOptionalHelp')}</CardContentText>
        </Grid>
      </Grid>
    </DialogContent>
  )
}

export default newWithEditModal(LeisureActivityModal)
